<template>
    <div v-if="resetButtonIsVisible">
        <a href="#" class="resetLink" @click.prevent="handleReset">
            Reset <span class="s-hide">filter</span>
            <i class="fa fa-ban"></i>
        </a>
    </div>
</template>

<script>
    import {EventBus} from "../../events";

    export default {
        name: "FilterReset",
        props: {
            name: {
                required: false,
                type: [Array, String],
                default: null,
            }
        },
        data() {
            return {
                resetButtonIsVisible: false,
            }
        },
        methods: {
            handleReset() {
                let url = window.location.href;
                let index = url.indexOf('?');

                if (index !== -1) {
                    url = url.substring(0, index);
                }

                if (url !== window.location.href) {
                    window.location.href = url;
                }
            },
            checkIfNeedToBeVisible() {
                this.resetButtonIsVisible = window.location.href.indexOf('?') !== -1;
            }
        },
        computed: {
            filter() {
                return this.$store.getters['filter/get'];
            },
        },
        created() {
            EventBus.$on('filter_updated', () => {
                this.checkIfNeedToBeVisible()
            });
        },
        mounted() {
            this.checkIfNeedToBeVisible();
        },
    }
</script>

<style scoped lang="scss">
    .resetLink {
        color: #6a6a6a;
        text-decoration: none;
        letter-spacing: 0.05em;
        line-height: 1;
        border: 1px solid #eee;
        padding: 4px 10px;

        i {
            color: #b5b5b5;
        }

        &:hover {
            color: black;
            background-color: #f9f9f9;

            i {
                color: #b9b9b9;
            }
        }
    }
</style>
